
import { computed, defineComponent, PropType, ref, watch } from 'vue'
import { ElMessage } from 'element-plus'
import { DefaultTaskTime, TaskTimeSetting } from '@/views/dashboard/_components/task-time/task-time.service'
import TaskTimeSelect from '@/views/dashboard/_components/task-time/task-time-select.vue'

export default defineComponent({
  emits: ['update:modelValue', 'add'],

  components: {
    TaskTimeSelect
  },
  props: {
    mixType: {
      type: Number,
      default: 1
    },
    mainSwitch: {
      type: Boolean,
      default: false
    },
    modelValue: {
      type: Array as PropType<TaskTimeSetting[]>,
      default: () => [ ...DefaultTaskTime ]
    },
    /** true: 显示和处理start_min、end_min。  false：不显示处理start_min */
    isRange: {
      type: Boolean,
      default: true
    },
    defaultStartMin: {
      type: Number,
      default: 0
    },
    defaultEndMin: {
      type: Number,
      default: 10
    },
    frequencyKey: {
      type: String,
      default: 'frequency'
    },
    maxTasks: {
      type: Number,
      default: 5
    }
  },
  setup (props, context) {
    const compData = ref<TaskTimeSetting[]>(props.modelValue)
    const hasAfterRow = computed(
      () => !!(context.slots['after-tip'] || context.slots['after-extra']),
    )

    function subSelector (idx: number) {
      if (!props.mainSwitch) {
        return
      }
      if (compData.value.length === 1) {
        ElMessage.error('至少保留1个定时任务')
        return
      }
      compData.value.splice(idx, 1)
    }

    function addSelector () {
      if (!props.mainSwitch) {
        return
      }
      if (compData.value.length >= props.maxTasks) {
        ElMessage.error(`最多添加${props.maxTasks}个定时任务`)
        return
      }
      compData.value.push({ target: 1, start_min: props.defaultStartMin, end_min: props.defaultEndMin })
      const addIndex = compData.value.length - 1
      context.emit('add', addIndex)
    }

    watch(compData, (value) => {
      const result = value.map(v => {
        if (!props.isRange && v.end_min !== undefined) {
          return { ...v, end_min: undefined }
        }
        return v
      })
      context.emit('update:modelValue', result)
    }, { deep: true })

    watch(() => props.modelValue, (newVal, oldValue) => {
      if (JSON.stringify(newVal) !== JSON.stringify(oldValue)) {
        compData.value = props.modelValue
      }
    })

    return {
      compData,
      subSelector,
      addSelector,
      hasAfterRow,
    }
  }
})
